module.exports = __webpack_public_path__ + "img/process@2x.694bbca4.webp";